export interface ActiveEmergency {
  latitude: number;
  longitude: number;
  eventId: string;
  incidentId: string;
}

const STORAGE_KEY = 'c2_emergency_location';

export function persistEmergencyLocation(emergency: ActiveEmergency): void {
  try {
    localStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({ ...emergency, timestamp: Date.now() })
    );
  } catch {
    /* ignore */
  }
}

export function readEmergencyLocation(): (ActiveEmergency & { timestamp?: number }) | null {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (
      typeof parsed.latitude !== 'number' ||
      typeof parsed.longitude !== 'number' ||
      !parsed.eventId ||
      !parsed.incidentId
    ) {
      localStorage.removeItem(STORAGE_KEY);
      return null;
    }
    return parsed;
  } catch {
    return null;
  }
}

export function clearEmergencyLocationStorage(): void {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    /* ignore */
  }
}

/** True when an emergency applies to the currently viewed event. */
export function emergencyMatchesEvent(
  emergency: ActiveEmergency | null | undefined,
  eventId: string | null | undefined
): emergency is ActiveEmergency {
  return !!emergency && !!eventId && emergency.eventId === eventId;
}
